import React, { useState } from 'react';
import { useAdminTheme } from '../contexts/AdminThemeContext';
import Icon from './AppIcon';

const UserApprovals = () => {
  console.log('🚀 UserApprovals component initializing');
  const { currentColors } = useAdminTheme();
  const [pendingUsers, setPendingUsers] = useState([
    {
      id: 'user-pending-1',
      user_id: 'user-pending-1',
      status: 'pending',
      created_at: '2024-02-20T10:30:00.000Z',
      user_profiles: {
        full_name: 'Michael Chen',
        email: 'michael.chen@datacorp.com',
        phone: '+1 (555) 789-0123',
        created_at: '2024-02-20T10:30:00.000Z'
      }
    },
    {
      id: 'user-pending-2',
      user_id: 'user-pending-2',
      status: 'pending',
      created_at: '2024-02-19T14:15:00.000Z',
      user_profiles: {
        full_name: 'Emily Davis',
        email: 'emily.davis@globaltech.com',
        phone: '+1 (555) 890-1234',
        created_at: '2024-02-19T14:15:00.000Z'
      }
    },
    {
      id: 'user-pending-3',
      user_id: 'user-pending-3',
      status: 'pending',
      created_at: '2024-02-18T16:45:00.000Z',
      user_profiles: {
        full_name: 'Robert Johnson',
        email: 'robert.johnson@innovate.com',
        phone: '+1 (555) 901-2345',
        created_at: '2024-02-18T16:45:00.000Z'
      }
    }
  ]);
  const [approvedUsers, setApprovedUsers] = useState([
    {
      id: 'user-approved-1',
      user_id: 'user-approved-1',
      status: 'approved',
      created_at: '2024-02-15T09:20:00.000Z',
      user_profiles: {
        full_name: 'John Smith',
        email: 'john.smith@techcorp.com',
        phone: '+1 (555) 567-8901',
        created_at: '2024-02-15T09:20:00.000Z'
      }
    },
    {
      id: 'user-approved-2',
      user_id: 'user-approved-2',
      status: 'approved',
      created_at: '2024-02-12T11:30:00.000Z',
      user_profiles: {
        full_name: 'Sarah Johnson',
        email: 'sarah.johnson@innovatecorp.com',
        phone: '+1 (555) 678-9012',
        created_at: '2024-02-12T11:30:00.000Z'
      }
    },
    {
      id: 'user-approved-3',
      user_id: 'user-approved-3',
      status: 'approved',
      created_at: '2024-02-10T13:45:00.000Z',
      user_profiles: {
        full_name: 'David Wilson',
        email: 'david.wilson@fintech.com',
        phone: '+1 (555) 901-2345',
        created_at: '2024-02-10T13:45:00.000Z'
      }
    },
    {
      id: 'user-approved-4',
      user_id: 'user-approved-4',
      status: 'approved',
      created_at: '2024-02-08T15:10:00.000Z',
      user_profiles: {
        full_name: 'Lisa Brown',
        email: 'lisa.brown@cloudservices.com',
        phone: '+1 (555) 012-3456',
        created_at: '2024-02-08T15:10:00.000Z'
      }
    }
  ]);
  const [rejectedUsers, setRejectedUsers] = useState([
    {
      id: 'user-rejected-1',
      user_id: 'user-rejected-1',
      status: 'rejected',
      created_at: '2024-02-05T12:00:00.000Z',
      rejection_reason: 'Incomplete company information provided',
      user_profiles: {
        full_name: 'Tom Anderson',
        email: 'tom.anderson@startup.com',
        phone: '+1 (555) 123-4567',
        created_at: '2024-02-05T12:00:00.000Z'
      }
    }
  ]);
  const [activeTab, setActiveTab] = useState('pending');
  const [searchTerm, setSearchTerm] = useState('');
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [rejectReason, setRejectReason] = useState('');

  const approveUser = async (userId) => {
    console.log('🚀 Starting user approval process for ID:', userId);
    try {
      // Find the user in pending list and move to approved
      const userToApprove = pendingUsers.find(user => user.user_id === userId);
      if (userToApprove) {
        console.log('✅ Found user to approve:', userToApprove.user_profiles?.full_name);
        setPendingUsers(prev => prev.filter(user => user.user_id !== userId));
        setApprovedUsers(prev => [{
          ...userToApprove,
          status: 'approved'
        }, ...prev]);
        console.log('✅ User moved to approved list');
        alert('User approved successfully!');
      } else {
        console.error('❌ User not found in pending list:', userId);
        alert('User not found in pending approvals');
      }
    } catch (error) {
      console.error('❌ Error approving user:', error);
      alert('Error approving user: ' + error.message);
    }
  };

  const rejectUser = async () => {
    console.log('🚀 Starting user rejection process');
    try {
      if (!selectedUser || !rejectReason.trim()) {
        console.log('❌ Missing user or rejection reason');
        alert('Please provide a reason for rejection');
        return;
      }

      console.log('🔍 Rejecting user:', selectedUser.user_profiles?.full_name);
      console.log('📝 Rejection reason:', rejectReason);

      // Find the user in pending list and move to rejected
      const userToReject = pendingUsers.find(user => user.user_id === selectedUser.user_id);
      if (userToReject) {
        console.log('✅ Found user to reject, moving to rejected list');
        setPendingUsers(prev => prev.filter(user => user.user_id !== selectedUser.user_id));
        setRejectedUsers(prev => [{
          ...userToReject,
          status: 'rejected',
          rejection_reason: rejectReason
        }, ...prev]);
        console.log('✅ User moved to rejected list');
        alert('User rejected successfully!');
      } else {
        console.error('❌ User not found in pending list');
        alert('User not found in pending approvals');
      }

      setShowRejectModal(false);
      setSelectedUser(null);
      setRejectReason('');
      console.log('🧹 Modal closed and state reset');

    } catch (error) {
      console.error('❌ Error rejecting user:', error);
      alert('Error rejecting user: ' + error.message);
    }
  };

  const filterUsers = (users) => {
    if (!searchTerm) return users;
    return users.filter(user => 
      user.user_profiles?.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.user_profiles?.email?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const createTestUser = async () => {
    console.log('🧪 Creating test user...');
    try {
      const testEmail = `testuser_${Date.now()}@example.com`;
      const testUserId = `test-user-${Date.now()}`;

      console.log('📧 Generated test email:', testEmail);
      console.log('🆔 Generated test user ID:', testUserId);

      const testUser = {
        id: testUserId,
        user_id: testUserId,
        status: 'pending',
        created_at: new Date().toISOString(),
        user_profiles: {
          full_name: 'Test User Pending',
          email: testEmail,
          phone: '+1 (555) 999-9999',
          created_at: new Date().toISOString()
        }
      };

      console.log('👤 Test user object created:', testUser);

      // Add to pending users list
      setPendingUsers(prev => [testUser, ...prev]);
      console.log('✅ Test user added to pending list');

      alert(`Test user created successfully! Added ${testEmail} to pending approvals.`);
    } catch (error) {
      console.error('❌ Error creating test user:', error);
      alert('Error creating test user: ' + error.message);
    }
  };

  const UserCard = ({ approval, showActions = true }) => {
    console.log('🔍 UserCard rendering for:', approval.user_profiles?.full_name || 'Unknown User');
    return (
    <div
      style={{
        background: currentColors.cardBackground,
        border: `1px solid ${currentColors.border}`,
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '16px',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
        {/* Avatar */}
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: approval.user_profiles?.avatar_url
              ? `url(${approval.user_profiles.avatar_url})`
              : `linear-gradient(135deg, ${currentColors.primary}, ${currentColors.secondary})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold'
          }}
        >
          {!approval.user_profiles?.avatar_url && 
            (approval.user_profiles?.full_name?.charAt(0) || approval.user_profiles?.email?.charAt(0) || '?').toUpperCase()
          }
        </div>

        {/* User Info */}
        <div style={{ flex: 1 }}>
          <h3 style={{ 
            color: currentColors.text, 
            margin: '0 0 8px 0', 
            fontSize: '18px',
            fontWeight: '600'
          }}>
            {approval.user_profiles?.full_name || 'Unknown User'}
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Icon name="Mail" size={14} style={{ color: currentColors.textSecondary }} />
              <span style={{ color: currentColors.textSecondary, fontSize: '14px' }}>
                {approval.user_profiles?.email || 'No email provided'}
              </span>
            </div>
            
            {approval.user_profiles?.phone && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon name="Phone" size={14} style={{ color: currentColors.textSecondary }} />
                <span style={{ color: currentColors.textSecondary, fontSize: '14px' }}>
                  {approval.user_profiles.phone}
                </span>
              </div>
            )}
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Icon name="Calendar" size={14} style={{ color: currentColors.textSecondary }} />
              <span style={{ color: currentColors.textSecondary, fontSize: '14px' }}>
                Registered: {new Date(approval.created_at).toLocaleDateString()}
              </span>
            </div>

            {approval.rejection_reason && (
              <div style={{ 
                marginTop: '8px',
                padding: '8px 12px',
                backgroundColor: currentColors.error + '20',
                borderRadius: '6px',
                borderLeft: `3px solid ${currentColors.error}`
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                  <Icon name="AlertCircle" size={14} style={{ color: currentColors.error }} />
                  <span style={{ color: currentColors.error, fontSize: '12px', fontWeight: '600' }}>
                    Rejection Reason:
                  </span>
                </div>
                <p style={{ color: currentColors.error, fontSize: '12px', margin: 0 }}>
                  {approval.rejection_reason}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        {showActions && approval.status === 'pending' && (
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => {
                console.log('✅ Approving user:', approval.user_profiles?.full_name);
                approveUser(approval.user_id);
              }}
              style={{
                background: currentColors.success,
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <Icon name="Check" size={14} />
              Approve
            </button>

            <button
              onClick={() => {
                console.log('❌ Opening reject modal for:', approval.user_profiles?.full_name);
                setSelectedUser(approval);
                setShowRejectModal(true);
              }}
              style={{
                background: currentColors.error,
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <Icon name="X" size={14} />
              Reject
            </button>
          </div>
        )}

        {/* Status Badge */}
        {approval.status !== 'pending' && (
          <div
            style={{
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: approval.status === 'approved' ? currentColors.success + '20' : currentColors.error + '20',
              color: approval.status === 'approved' ? currentColors.success : currentColors.error,
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <Icon 
              name={approval.status === 'approved' ? 'CheckCircle' : 'XCircle'} 
              size={12} 
            />
            {approval.status.charAt(0).toUpperCase() + approval.status.slice(1)}
          </div>
        )}
      </div>
    </div>
    );
  };

  const tabs = [
    { id: 'pending', label: 'Pending Approval', count: pendingUsers.length, color: currentColors.warning },
    { id: 'approved', label: 'Approved', count: approvedUsers.length, color: currentColors.success },
    { id: 'rejected', label: 'Rejected', count: rejectedUsers.length, color: currentColors.error },
  ];

  const getCurrentUsers = () => {
    switch (activeTab) {
      case 'pending': return filterUsers(pendingUsers);
      case 'approved': return filterUsers(approvedUsers);
      case 'rejected': return filterUsers(rejectedUsers);
      default: return [];
    }
  };


  return (
    <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '24px' }}>
        <h2 style={{ color: currentColors.text, margin: '0 0 8px 0', fontSize: '24px', fontWeight: '700' }}>
          User Approvals
        </h2>
        <p style={{ color: currentColors.textSecondary, margin: 0, fontSize: '14px' }}>
          Manage user access requests and approve new members
        </p>
      </div>

      {/* Search Bar */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ position: 'relative', maxWidth: '400px' }}>
          <Icon 
            name="Search" 
            size={16} 
            style={{ 
              position: 'absolute', 
              left: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              color: currentColors.textSecondary 
            }} 
          />
          <input
            type="text"
            placeholder="Search users by name or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 12px 12px 40px',
              border: `1px solid ${currentColors.border}`,
              borderRadius: '8px',
              fontSize: '14px',
              backgroundColor: currentColors.background,
              color: currentColors.text,
              outline: 'none'
            }}
          />
        </div>
      </div>

      {/* Tabs */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', gap: '8px', borderBottom: `1px solid ${currentColors.border}` }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 20px',
                border: 'none',
                background: 'transparent',
                color: activeTab === tab.id ? tab.color : currentColors.textSecondary,
                borderBottom: activeTab === tab.id ? `2px solid ${tab.color}` : '2px solid transparent',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {tab.label}
              {tab.count > 0 && (
                <span
                  style={{
                    background: tab.color,
                    color: 'white',
                    fontSize: '12px',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    minWidth: '20px',
                    textAlign: 'center'
                  }}
                >
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Users List */}
      <div>
        {getCurrentUsers().length === 0 ? (
          <div
            style={{
              textAlign: 'center',
              padding: '60px 20px',
              color: currentColors.textSecondary
            }}
          >
            <Icon name="Users" size={48} style={{ opacity: 0.3, marginBottom: '16px' }} />
            <h3 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>
              No {activeTab} users found
            </h3>
            <p style={{ margin: 0, fontSize: '14px' }}>
              {searchTerm ? 'Try adjusting your search criteria' : `No users with ${activeTab} status`}
            </p>
          </div>
        ) : (
          getCurrentUsers().map(approval => (
            <UserCard 
              key={approval.id} 
              approval={approval} 
              showActions={activeTab === 'pending'}
            />
          ))
        )}
      </div>

      {/* Reject Modal */}
      {showRejectModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: currentColors.cardBackground,
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto'
          }}>
            <h3 style={{ color: currentColors.text, margin: '0 0 16px 0' }}>
              Reject User Application
            </h3>
            
            <p style={{ color: currentColors.textSecondary, marginBottom: '16px' }}>
              Please provide a reason for rejecting {selectedUser?.user_profiles?.full_name || 'this user'}:
            </p>

            <textarea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter rejection reason..."
              style={{
                width: '100%',
                minHeight: '100px',
                padding: '12px',
                border: `1px solid ${currentColors.border}`,
                borderRadius: '8px',
                fontSize: '14px',
                backgroundColor: currentColors.background,
                color: currentColors.text,
                resize: 'vertical',
                marginBottom: '20px'
              }}
            />

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowRejectModal(false);
                  setSelectedUser(null);
                  setRejectReason('');
                }}
                style={{
                  padding: '10px 20px',
                  border: `1px solid ${currentColors.border}`,
                  borderRadius: '6px',
                  background: 'transparent',
                  color: currentColors.text,
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              
              <button
                onClick={rejectUser}
                disabled={!rejectReason.trim() || loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: currentColors.error,
                  color: 'white',
                  cursor: rejectReason.trim() ? 'pointer' : 'not-allowed',
                  opacity: rejectReason.trim() ? 1 : 0.5
                }}
              >
                {loading ? 'Rejecting...' : 'Reject User'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    );
  };

export default UserApprovals;
